import React, { useContext } from "react";
import moment from "moment";
import { Link, useHistory, useParams } from "react-router-dom";
import { firestore } from "../firebase";
import { useUserProvider } from "../context/UserProvider";
import { useConfirm } from "material-ui-confirm";

import {
  Card,
  Box,
  IconButton,
  Typography,
  TableCell,
  TableRow,
  CardContent,
  Grid,
  useMediaQuery,
  TextField,
  Chip,
  Table,
  TableBody,
} from "@mui/material";

import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Stack } from "react-bootstrap";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import DeleteIcon from "@mui/icons-material/Delete";

import aerialNoisesIconWhite from "../images/aerial_noises_white.svg";
import impactNoisesIconWhite from "../images/impact_noises_white.svg";

import aerialNoisesIcon from "../images/aerial_noises.svg";
import impactNoisesIcon from "../images/impact_noises.svg";

import { toast } from "react-toastify"; // then this

import { ColorModeContext } from "../context/ColorModeProvider";

export default function Measurement(props) {
  const { theme } = useContext(ColorModeContext);

  const existingField = [
    props.formData.typeOfNoise,
    props.formData.directionOfEmission,
    props.formData.typeOfNoise,
    props.formData.spectrumOfMeasurements,
    props.formData.DnTw_100_3150Hz,
    props.formData.C_100_3150Hz,
    props.formData.CTR_100_3150Hz,
    props.formData.cs_100Hz,
    props.formData.cs_125Hz,
    props.formData.cs_160Hz,
    props.formData.cs_200Hz,
    props.formData.cs_250Hz,
    props.formData.cs_315Hz,
    props.formData.cs_400Hz,
    props.formData.cs_500Hz,
    props.formData.cs_630Hz,
    props.formData.cs_800Hz,
    props.formData.cs_1000Hz,
    props.formData.cs_1250Hz,
    props.formData.cs_1600Hz,
    props.formData.cs_2000Hz,
    props.formData.cs_2500Hz,
    props.formData.cs_3150Hz,
  ];

  function isEmptyString(operand) {
    return operand != "" ? "full" : "empty";
  }

  function isEmpty(current) {
    return isEmptyString(current) === "full" ? true : false;
  }

  const confirm = useConfirm();

  const siteId = props.siteId;
  const wallId = props.wallId;
  const measurementId = props.id;

  // const { id } = useParams();

  const siteRef = firestore.doc(`sites/${siteId}`);

  const remove = () =>
    siteRef
      .collection("walls")
      .doc(wallId)
      .collection("measurements")
      .doc(measurementId)
      .delete()
      .then(() =>
        //  Alert.info("Post Deleted", 3000)
        toast.info("Measurement deleted", {
          theme: "colored",
        })
      );

  const { user: currentUser } = useUserProvider();
  const location = useHistory().location.pathname;

  const belongsToCurrentUser = (currentUser, siteAuthor) => {
    if (!currentUser) return false;

    return currentUser.uid === siteAuthor.uid;
  };

  const handleDelete = () => {
    confirm({
      title: "Are you sure?",
      description: "This will permanently delete this measurement.",
    }).then(() => remove());
  };
  const registr = props.formData.registrationPeriod;

  const { nanoseconds, seconds } = props.createdAt !== null && props.createdAt;
  var timestamp = { nanoseconds, seconds };
  const dateTime = new Date(timestamp?.seconds * 1000);

  const isMediumScreenAndDown = useMediaQuery((theme) =>
    theme.breakpoints.down("md")
  );

  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only("xs"));

  return (
    <>
      {/* <p>{props.sideRoom2Name}</p> */}
      <Card
        elevation={0}
        sx={{
          marginBottom: {
            xs: "14px",
            sm: "22px",
            md: "22px",
            lg: "22px",
          },
        }}
      >
        <Table>
          <TableBody>
            <TableRow
              style={{
                width: "100%",
                borderBottom: "none",
              }}
            >
              <TableCell
                sx={{
                  borderBottom: "none",
                  // background: "purple",
                  width: {
                    xs: "50%",
                    sm: "30%",
                    md: "30%",
                    lg: "30%",
                  },
                  pl: {
                    xs: 2,
                    sm: 3,
                    md: 3,
                    lg: 3,
                  },
                  pr: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                size="medium"
                // colSpan={6}
                align="left"
                // style={{ width: "30%" }}
              >
                <Typography variant="body2">
                  {props.formData.directionOfEmission}
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  borderBottom: "none",
                  // background: "red",
                  pl: 0,
                  pr: 0,
                }}
                // size="medium"
                // colSpan={6}
                align="right"
              >
                {props.formData.typeOfNoise === "Impact noises" &&
                theme.palette.mode === "dark" ? (
                  <img
                    src={impactNoisesIconWhite}
                    align="center"
                    width="40px"
                  />
                ) : props.formData.typeOfNoise === "Impact noises" &&
                  theme.palette.mode === "light" ? (
                  <img src={impactNoisesIcon} align="center" width="40px" />
                ) : props.formData.typeOfNoise === "Aerial noises" &&
                  theme.palette.mode === "dark" ? (
                  <img
                    src={aerialNoisesIconWhite}
                    align="center"
                    width="40px"
                  />
                ) : props.formData.typeOfNoise === "Aerial noises" &&
                  theme.palette.mode === "light" ? (
                  <img src={aerialNoisesIcon} align="center" width="40px" />
                ) : (
                  "err"
                )}
              </TableCell>
              {/* <TableCell>{formData.roomDisposalDependingAfterWorks}</TableCell> */}

              <TableCell
                sx={{
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  maxWidth: {
                    xs: "3.6em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  borderBottom: "none",
                  pt: "28px",
                  pb: "28px",
                  pl: 0,
                  pr: 0,
                  // clear: "both",
                }}
                size="small"
                // colSpan={6}
                align="center"
              >
                <Typography color="inherit" variant="subtitle1">
                  <Chip
                    style={{
                      // color: "#fff",
                      textTransform: "uppercase",
                      fontWeight: "600",
                      fontSize: "0.8em",
                      letterSpacing: "0.5px",
                      padding: "0px 2px 0px 2px ",
                      textTransform: "uppercase",
                      height: "28px",
                      lineHeight: "28px",
                      justifyContent: "center",
                      whiteSpace: "nowrap",
                      background: "transparent",
                    }}
                    // color="primary"
                    // icon={<TimelapseIcon fontSize="small" />}
                    label={
                      isMediumScreenAndDown
                        ? props.registrationPeriod === "Before Works"
                          ? "BW"
                          : "AW"
                        : props.registrationPeriod
                    }
                  />
                </Typography>
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "none",
                  // background: "yellow",
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },

                  p: 0,
                  pr: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                  pl: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                size="small"
                align="right"
              >
                {existingField.every(isEmpty) ? (
                  <CheckCircleIcon
                    align="center"
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{
                      color: "#00BFC6",
                      justifyContent: "center",
                      mt: 1,
                    }}
                  />
                ) : (
                  <TimelapseIcon
                    fontSize={isSmallScreen ? "small" : "medium"}
                    sx={{ justifyContent: "center", color: "#8D9EB7", mt: 1 }}
                  />
                )}
              </TableCell>
              <TableCell
                sx={{
                  borderBottom: "none",
                  width: {
                    xs: "1em",
                    sm: "6em",
                    md: "6em",
                    lg: "6em",
                  },
                  pr: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                  pl: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                align="right"
              >
                {props.user &&
                belongsToCurrentUser(currentUser, props.user) &&
                location !== `/measurements/${measurementId}` ? (
                  <IconButton
                    aria-label="delete"
                    onClick={() => handleDelete()}
                  >
                    <DeleteIcon
                      fontSize={isSmallScreen ? "small" : "medium"}
                      style={{ justifyContent: "center", color: "#6593B5" }}
                    />
                  </IconButton>
                ) : (
                  ""
                )}
              </TableCell>

              <TableCell
                sx={{
                  borderBottom: "none",
                  // background: "green",
                  width: "1em",
                  pl: {
                    xs: 0,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                  pr: {
                    xs: 0.5,
                    sm: 2,
                    md: 2,
                    lg: 2,
                  },
                }}
                align="right"
              >
                <Link
                  to={{
                    pathname: `/measurements/${measurementId}/`,
                    state: { props },
                    // `/walls/${propsWallId}`
                  }}
                >
                  <IconButton aria-label="edit">
                    <NavigateNextIcon />
                  </IconButton>
                </Link>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </Card>
    </>
  );
}
